module.exports = __webpack_public_path__ + "4746663d312fc651af5655a9c8fb5718.png";